import { Component, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { EmailConfirmDTO } from 'src/app/core/models/auth';
import { AuthService } from 'src/app/core/services/shared-services/auth.service';
import { UserRegistrationService } from 'src/app/core/services/user-registration.service';

@Component({
  selector: 'eb-profile-setup-v2',
  templateUrl: './profile-setup-v2.component.html',
})
export class ProfileSetupV2Component implements OnInit {

  constructor(

  ) { }

  ngOnInit() {

  }


}
